import { format } from "date-fns";
import { nl } from "date-fns/locale";

const getDaysOfMonth = (input: Date) => {
    const date = new Date(input);
    date.setDate(1);
    const month = date.getMonth();
    const days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
};

const datesEqual = (a: Date, b: Date) => a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();

export const minuteMs = 1000 * 60;
export const hourMs = minuteMs * 60;
export const dayMs = hourMs * 24;

function dateAdd(date: Date | null | undefined, ms: number): Date {
    date = date || new Date();
    return new Date(date.getTime() + ms);
}
const getToday = () => {
    const d = new Date();
    d.setHours(23, 59, 59);
    return d;
};

function getTimeInHours(date: any) {
    if (date && date.getHours) {
        return date.getHours() + (date.getMinutes() / 60);
    }
    return 0;
}

function dateOverlap(min1: Date, max1: Date, min2: Date, max2: Date): number {
    return rangeOverlap(min1.getTime(), max1.getTime(), min2.getTime(), max2.getTime())
}

function rangeOverlap(min1: number, max1: number, min2: number, max2: number): number {
    if (min1 > max1 || min2 > max2) {
        throw new Error("Invalid range");
    }
    if (max2 <= min1 || min2 >= max1) /* A + B */ {
        return 0;
    }
    if (min1 <= min2 && max1 >= max2) /* C */ {
        return max2 - min2;
    }
    if (min1 >= min2 && max1 <= max2) /* D */ {
        return max1 - min1;
    }
    if (min1 >= min2 && max1 >= max2 && max2 >= min1) /* E */ {
        return max2 - min1;
    }
    if (min1 <= min2 && max1 >= min2 && max2 >= max1) /* F */ {
        return max1 - min2;
    }
    throw new Error("Invalid case");
}


const isoDateString = (date: Date) => date.toISOString().slice(0, 10);

const todayString = () => {
    return isoDateString(new Date())
}

enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Thuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

// function isWeekEnd(date: Date) {
//     return [DayOfWeek.Sunday, DayOfWeek.Saturday].includes(date.getDay());
// }

// function isToday(date: Date) {
//     return datesEqual(date, new Date());
// }

function dateFormat(date: any, formatStr: string) {
    return format(date, formatStr, { locale: nl });
}

export {
    DayOfWeek, getDaysOfMonth, datesEqual, dateAdd, getToday, getTimeInHours, isoDateString, todayString, dateFormat, dateOverlap
    // isWeekEnd,
    // isToday
};

